import { Skeleton, Stack, Typography } from '@mui/material';
import { Paper } from '@shared/components';

interface Props {
  heading: string;
  aggregatedInfo: string | number;
  aggregatedAdditionalInfo?: React.ReactNode;
  negativeChange?: boolean;
  isLoadingFetchItems: boolean;
  headerSize?: 'large' | 'small';
  variant?: 'outlined';
}

export function AggregatedInfoPaper({
  heading,
  aggregatedInfo,
  aggregatedAdditionalInfo,
  negativeChange,
  isLoadingFetchItems,
  headerSize = 'large',
  variant,
}: Props) {
  return (
    <Paper variant={variant} sx={{ p: 2, width: '100%' }}>
      <Stack display="grid" gridTemplateRows="1fr 0.5fr 0.5fr" height="100%">
        <Typography variant="subtitle2" color="textSecondary" fontWeight={700} pb={1}>
          {heading}
        </Typography>
        <Typography
          variant={headerSize === 'large' ? 'h2' : 'h4'}
          color={
            negativeChange === true ? 'error' : negativeChange === false ? 'success' : 'primary'
          }
        >
          {isLoadingFetchItems ? <Skeleton variant="text" width={80} /> : aggregatedInfo}
        </Typography>
        {aggregatedAdditionalInfo}
      </Stack>
    </Paper>
  );
}
